export const DEFAULT_SW_CONTROLLER_WAIT_TIMEOUT_MS = 30000;

export function hasServiceWorkerController(serviceWorker) {
    return !!(serviceWorker && serviceWorker.controller);
}

export function waitForServiceWorkerController(serviceWorker, timeoutMs) {
    if (!serviceWorker || typeof serviceWorker.addEventListener !== 'function') {
        return Promise.resolve(false);
    }

    if (hasServiceWorkerController(serviceWorker)) {
        return Promise.resolve(true);
    }

    var waitTimeoutMs = typeof timeoutMs === 'number'
        ? timeoutMs
        : DEFAULT_SW_CONTROLLER_WAIT_TIMEOUT_MS;

    return new Promise(function (resolve) {
        var timeoutId = null;
        var didResolve = false;

        function finish(hasController) {
            if (didResolve) {
                return;
            }
            didResolve = true;
            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }
            if (typeof serviceWorker.removeEventListener === 'function') {
                serviceWorker.removeEventListener('controllerchange', onControllerChange);
            }
            resolve(hasController);
        }

        function onControllerChange() {
            finish(hasServiceWorkerController(serviceWorker));
        }

        timeoutId = setTimeout(function () {
            finish(false);
        }, waitTimeoutMs);

        serviceWorker.addEventListener('controllerchange', onControllerChange, { once: true });
    });
}
